// 🔥 Confirm Dialog
export const confirmAction = async (text) => {
  const result = await Swal.fire({
    title: "Are you sure?",
    text,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#1A237E",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes",
  });

  return result.isConfirmed;
};

// 🔥 Success Alert
export const successAlert = (text) => {
  return Swal.fire({
    icon: "success",
    title: "Success",
    text,
    timer: 2000,
    showConfirmButton: false,
  });
};

// 🔥 Error Alert
export const errorAlert = (text) => {
  Swal.fire({
    icon: "error",
    title: "Error",
    text,
  });
};
